import tokens from './tokens'
import { SUPRA_MAINNET_CHAIN_ID, SUPRA_TESTNET_CHAIN_ID } from './chains'
import { FarmConfig } from './types'

// Planned allocation points of pid 0, the xTOON pool, so the planned total matches the add-pool script
export const XTOON_POOL_PLANNED_ALLOC_POINT = 3818

// LP farms on the MasterChef. pid must equal the MasterChef pid; pid 0 is the xTOON pool on the Staking page.
// ETH and BTC sides are WETH and WBTC, which is what the pairs hold.
// plannedAllocPoint is what scripts/interactions/masterchef_add_pool.ts in toonswap-contracts gives each pool.
const farms: FarmConfig[] = [
  {
    pid: 1,
    lpSymbol: 'TOON-SUPRA',
    plannedAllocPoint: 6000,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0xc47A0393410DA31742AF07e1e7aAa23a6cF9245d',
    },
    token: tokens.bow,
    quoteToken: tokens.supra,
  },
  {
    pid: 2,
    lpSymbol: 'SUPRA-USDC',
    plannedAllocPoint: 500,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0xB69b13b3Db8E924347f5450b67921C49849Ad728',
    },
    token: tokens.supra,
    quoteToken: tokens.usdc,
  },
  {
    pid: 3,
    lpSymbol: 'SUPRA-USDT',
    plannedAllocPoint: 500,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0xB3436fe1A1e8A590DB4101F2F03287a703F0D479',
    },
    token: tokens.supra,
    quoteToken: tokens.usdt,
  },
  {
    pid: 4,
    lpSymbol: 'SUPRA-ETH',
    plannedAllocPoint: 500,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0x63E175C10ef4bBbb93D6004a2B1b9F5c072caf6B',
    },
    token: tokens.supra,
    quoteToken: tokens.wcore,
  },
  {
    pid: 5,
    lpSymbol: 'ETH-USDC',
    plannedAllocPoint: 300,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0x002163D263d6d87341059A2b8136A7ac9E3c338a',
    },
    token: tokens.wcore,
    quoteToken: tokens.usdc,
  },
  {
    pid: 6,
    lpSymbol: 'USDT-USDC',
    plannedAllocPoint: 200,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0xB067c6EE025Fead5cA8093A9E99FbC399069A6F1',
    },
    token: tokens.usdt,
    quoteToken: tokens.usdc,
  },
  {
    pid: 7,
    lpSymbol: 'ETH-BTC',
    plannedAllocPoint: 300,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0x8C2ab350Eb6C759C083bbeA2cC6e28b168254053',
    },
    token: tokens.wcore,
    quoteToken: tokens.wbtc,
  },
  {
    pid: 8,
    lpSymbol: 'TOON-PEPE',
    plannedAllocPoint: 50,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0xd885610fd948b8D5AceB55a9AbDbD1748Ec0Da0F',
    },
    token: tokens.pepe,
    // The site has no PEPE price, so the farm is valued from its TOON side
    quoteToken: tokens.bow,
  },
  {
    pid: 9,
    lpSymbol: 'PAW-USDC',
    plannedAllocPoint: 50,
    lpAddresses: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0xb067FdBaC9cD7e2c0B7879Dd58CD62eD7484D2f6',
    },
    token: tokens.paw,
    quoteToken: tokens.usdc,
  },
]

export default farms
